import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';
import type OptionsViewState from './schema/OptionsViewState';

export const getStore = createStore<OptionsViewState>('optionsViewState', {
    isFullOptionsShown: false,
    areAllAllowedSubCategoriesLoaded: false,
    isSaving: false,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (12,5): Type 'null' is not assignable to type 'string'.
    // @ts-ignore
    currentCategoryKey: null,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (16,5): Type 'null' is not assignable to type 'string'.
    // @ts-ignore
    currentSubCategoryKey: null,
    subCategoryLoadState: new ObservableMap(),
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (21,5): Type 'null' is not assignable to type 'string'.
    // @ts-ignore
    currentOptionKey: null,
    allowedOptions: [],
    dirtyOptions: [],
});
